




















import { Component } from 'vue-property-decorator';
import IssueItemBaseMixin from '@/components/ViewComponent/Issue/IssueItem/issue-item-base.mixin';
import IssueStatusBtn from '@/components/ViewComponent/Issue/IssueStatusBtn.vue';
import BtnResolveIssue from '@/components/ViewComponent/Issue/IssueDetail/BtnResolveIssue/BtnResolveIssue.vue';
import UserAvatar from '@/components/Helper/UserAvatar.vue';

@Component<IssueDetailHeaderPc>({
  components: {
    UserAvatar,
    BtnResolveIssue,
    IssueStatusBtn,
  },
})
export default class IssueDetailHeaderPc extends IssueItemBaseMixin {}
